<template>
  <div class="col-lg-12 ">
    <div class="hpanel futuristic-card">
      <br />
      <div class="panel-body">
        <div>
          <v-tabs v-model="active" slider-color="primary">
            <v-tab key="guest_details" ripple>
              <small>Step 1 - Guest Details</small>
            </v-tab>
            <v-tab key="residency" ripple>
              <small>Step 2 - Residency</small>
            </v-tab>
            <v-tab :key="3" ripple>
              <small>Step 3 - Vehicle Entry Fees</small>
            </v-tab>
            <v-tab :key="4" ripple>
              <small>Step 4 - Accommodation/Camping</small>
            </v-tab>
            <v-tab :key="5" ripple>
              <small>Step 5 - Activities</small>
            </v-tab>
            <v-tab
              v-if="proofOfResidency.length < 0"
              key="proofresidency"
              ripple
            >
              <small>Step 6 - Proof of Residency</small>
            </v-tab>
            <v-tab :key="6" ripple>
              <small>Step 7- Complete Booking</small>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active">
            <v-tab-item key="guest_details">
              <v-card flat>
                <v-layout v-if="route === 'PostponeBooking'" row wrap>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_in"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-in*"
                          v-model="gate_pass.check_in"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_in"
                          :min="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="
                              $refs.dialog.save(gate_pass.check_in),
                                endDate(gate_pass.check_in)
                            "
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-text-field
                        slot="activator"
                        label="Check-out*"
                        v-model="gate_pass.check_out"
                        :disabled="true"
                        readonly
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg12 md12 sm12 xs12>
                    <v-container fluid>
                      <v-autocomplete
                        label="Destination*"
                        v-model="gate_pass.destination"
                        :items="allDestinations"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="destination_name"
                        item-value="destination_public_id"
                        :disabled="true"
                        :loading="$loadingTrue"
                        @change="checkDestination"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="First Name"
                        v-model="gate_pass.first_name"
                        :rules="requiredRules"
                        :disabled="true"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Last Name"
                        v-model="gate_pass.last_name"
                        :rules="requiredRules"
                        :disabled="true"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Email"
                        v-model="gate_pass.email"
                        :rules="requiredRules"
                        required
                        :disabled="true"
                        type="email"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg2 md6 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Country"
                        v-model="gate_pass.code"
                        :items="allCountries"
                        :rules="[(v) => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        :disabled="true"
                        :loading="$loadingTrue"
                        @change="findCountryCode"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md6 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Phone Number (+***)"
                        v-model="gate_pass.phone"
                        type="tel"
                        hint="Start with country code."
                        :disabled="true"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container fluid>
                      <v-text-field
                        v-model="gate_pass.promo_code"
                        :disabled="true"
                        label="Promo Code"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg12 md6 sm12 xs12>
                    <v-container fluid>
                      <v-textarea
                        v-model="gate_pass.note"
                        :disabled="true"
                        label="Notes"
                      ></v-textarea>
                    </v-container>
                  </v-flex>
                </v-layout>

                <v-layout v-else row wrap>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_in"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-in*"
                          v-model="gate_pass.check_in"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_in"
                          :min="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(gate_pass.check_in)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_out"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-out*"
                          v-model="gate_pass.check_out"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_out"
                          :min="gate_pass.check_in"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(gate_pass.check_out)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container fluid>
                      <v-autocomplete
                        label="Destination*"
                        v-model="gate_pass.destination"
                        :items="allDestinations"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="destination_name"
                        item-value="destination_public_id"
                        :loading="$loadingTrue"
                        @change="checkDestination"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="First Name"
                        maxlength="39"
                        v-model="gate_pass.first_name"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Last Name"
                        maxlength="39"
                        v-model="gate_pass.last_name"
                        :rules="requiredRules"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Email"
                        v-model="gate_pass.email"
                        :rules="requiredRules"
                        required
                        type="email"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container fluid>
                      <v-autocomplete
                        label="Country*"
                        v-model="gate_pass.code"
                        :items="allCountries"
                        :rules="[(v) => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        :loading="$loadingTrue"
                        @change="findCountryCode"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Phone Number (+***)"
                        v-model="gate_pass.phone"
                        type="tel"
                        hint="Start with country code."
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container fluid>
                      <v-text-field
                        v-model="gate_pass.kra_pin_number"
                        label="KRA Pin"
                      ></v-text-field>
                    </v-container>
                  </v-flex>

                  <v-flex lg3 md3 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Mode of Entry"
                        v-model="gate_pass.entry_mode"
                        :items="allEntryModes"
                        item-text="entry_mode_name"
                        item-value="entry_mode_public_id"
                        @change="findEntryPoints"
                        :loading="$loadingTrue"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg3 md3 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Point of Entry"
                        v-model="gate_pass.entry_point"
                        :items="allEntryPoints"
                        item-text="gate_name"
                        item-value="gate_public_id"
                        :loading="$loadingTrue"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg3 md3 sm12 xs12 >
                    <v-container>
                      <v-text-field
                        v-model="gate_pass.mode_registration"
                        label="Mode registration Number"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg3 md3 sm12 xs12>
                    <v-container fluid>
                      <v-text-field
                        v-model="gate_pass.promo_code"
                        label="Promo Code"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  
                  <v-flex lg12 md6 sm12 xs12>
                    <v-container fluid>
                      <v-textarea
                        v-model="gate_pass.note"
                        label="Notes"
                      ></v-textarea>
                    </v-container>
                  </v-flex>
                  
                </v-layout>
              </v-card>
              <v-btn @click="nextTab()" fab round color="primary"
                ><v-icon>navigate_next</v-icon></v-btn
              >
            </v-tab-item>

            <v-tab-item key="residency">
       <v-container
  v-if="gate_pass.check_in === '' || gate_pass.destination === '' || gate_pass.code === ''"
>
  <p
    class="headline text-md-center text-lg-center error"
    style="color: white"
  >
    You need to select the Destination, Country, and Check-In Check-Out days
  </p>
</v-container>
              <conservation-fees
                v-else
                :check_in="gate_pass.check_in"
                :check_out="gate_pass.check_out"
                @update-total="conservationTotal = $event"
              ></conservation-fees>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item :key="3">
  <v-container v-if="conservationTotal < 0">
    <p
      class="headline text-md-center text-lg-center error"
      style="color: white"
    >
      Residency Total Amount must be greater than zero to proceed.
    </p>
  </v-container>

  <v-container v-else>
    <vehicle-fees
      :check_in="gate_pass.check_in"
      :check_out="gate_pass.check_out"
      @update-total="vehicleTotal = $event"
    ></vehicle-fees>

    <v-layout row wrap>
      <v-flex lg1 md1 sm6 xs6>
        <v-btn @click="previousTab()" fab round color="secondary">
          <v-icon>navigate_before</v-icon>
        </v-btn>
      </v-flex>
      <v-flex lg10 md10></v-flex>
      <v-flex lg1 md1 sm6 xs6>
        <v-btn @click="nextTab()" fab round color="primary">
          <v-icon>navigate_next</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</v-tab-item>


            <v-tab-item :key="4">
                <v-container v-if="vehicleTotal < 0">
    <p
      class="headline text-md-center text-lg-center error"
      style="color: white"
    >
      Total Amount total must be greater than zero to proceed.
    </p>
  </v-container>
  <v-container v-else>
              <v-card flat>
                <facility-booking></facility-booking>
                <v-layout row wrap>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="previousTab()" fab round color="secondary"
                      ><v-icon>navigate_before</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex lg10 md10></v-flex>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="nextTab()" fab round color="primary"
                      ><v-icon>navigate_next</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
              </v-container>
            </v-tab-item>

            <v-tab-item :key="5">
              <v-card flat>
                <inventory-booking></inventory-booking>
                <v-layout row wrap>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="previousTab()" fab round color="secondary"
                      ><v-icon>navigate_before</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex lg10 md10></v-flex>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="nextTab()" fab round color="primary"
                      ><v-icon>navigate_next</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>

            <v-tab-item key="proofresidency" v-if="proofOfResidency.length < 0">
              <v-card flat>
                <residency-proof></residency-proof>
                <v-layout row wrap>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="previousTab()" fab round color="secondary"
                      ><v-icon>navigate_before</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex lg10 md10></v-flex>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="nextTab()" fab round color="primary"
                      ><v-icon>navigate_next</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="6">
              <v-card flat>
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <td>Entry</td>
                          <td>Guests</td>
                          <td>Total Amount</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <b
                              >Conservation Fees for
                              <small>
                                {{
                                  getDays(
                                    gate_pass.check_in,
                                    gate_pass.check_out
                                  )
                                }}
                                days</small
                              ></b
                            >
                          </td>
                          <td>{{ getCoservationGuests() }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              conservationTotal
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <table>
                            <thead>
                              <tr>
                                <td>Residency</td>
                                <td>No of guests</td>
                                <td>Amount</td>
                                <td>Discount</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(c_fees, idx) in allConservationFees"
                                :key="'c_fee' + idx"
                              >
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_guests }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        c_fees.payment_person_currency,
                                        c_fees.payment_person_amount
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person_discount }}%
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>

                        <tr>
                          <td>
                            <b
                              >Vehicle Fees for<small>
                                {{
                                  getDays(
                                    gate_pass.check_in,
                                    gate_pass.check_out
                                  )
                                }}
                                days</small
                              ></b
                            >
                          </td>
                          <td>{{ getVehicleTotals() }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              vehicleTotal
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <table>
                            <thead>
                              <tr>
                                <td>Vehicle Type</td>
                                <td>No of Vehicles</td>
                                <td>Amount</td>
                                <td>Discount</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(v_fees, idx) in allVehicles"
                                :key="'v_fee' + idx"
                              >
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.vehicle_charge_category }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.vehicles }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        v_fees.vehicle_charge_cost_currency,
                                        v_fees.vehicle_charge_category_cost
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.discount }}%
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr>
                          <td><b>Accommodation</b></td>
                        </tr>
                        <tr v-if="chosenFacilities.length > 0"></tr>
                        <tr
                          v-for="(accommodation, index) in chosenFacilities"
                          :key="'acc' + index"
                        >
                          <td>{{ accommodation.name }}</td>
                          <td>
                            {{
                              Number(accommodation.children) +
                              Number(accommodation.adults)
                            }}
                          </td>
                          <td>
                            {{ $localCurrency }}
                            {{ $roundOff(facilityTotal(accommodation)) }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr v-if="bookedFacilities.length > 0"></tr>
                        <tr
                          v-for="(accommodation, index) in bookedFacilities"
                          :key="'acck' + index"
                        >
                          <td>{{ accommodation.facility_name }}</td>
                          <td>
                            {{
                              Number(accommodation.facility_booking_children) +
                              Number(accommodation.facility_booking_adults)
                            }}
                          </td>
                          <td>
                            {{ accommodation.facility_booking_currency }}
                            {{ oldFacilityTotal(accommodation) }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr>
                          <td><b>Ol Pejeta Escapes</b></td>
                        </tr>
                        <tr v-if="chosenExternalFacilities.length > 0"></tr>
                        <tr
                          v-for="(
                            accommodation, index
                          ) in chosenExternalFacilities"
                          :key="'acc' + index"
                        >
                          <td>
                            {{ accommodation.name }}({{
                              accommodation.facility_parameter_name
                            }})
                          </td>
                          <td>{{ totalExternalGuest(accommodation) }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              $roundOff(externalFacilityTotal(accommodation))
                            }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr v-if="finExternalFacilities.length > 0"></tr>
                        <tr
                          v-for="(
                            accommodation, index
                          ) in finExternalFacilities"
                          :key="'acc' + index"
                        >
                          <td>
                            {{ accommodation.facility_name }}({{
                              accommodation.pricing_parameter.parameter_name
                            }})
                          </td>
                          <td>{{ totalOldExternalGuest(accommodation) }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              $roundOff(
                                convert1(
                                  accommodation.facility_booking_currency,
                                  accommodation.facility_booking_total_cost
                                ).amount
                              )
                            }}
                          </td>
                        </tr>

                        <tr></tr>

                        <tr></tr>
                        <tr>
                          <td><b>Activities</b></td>
                        </tr>
                        <tr v-if="chosenInventory.length > 0"></tr>
                        <tr
                          v-for="(activity, index) in chosenInventory"
                          :key="'act' + index"
                        >
                          <td>{{ activity.name }}</td>
                          <td>
                            {{
                              Number(activity.children) +
                              Number(activity.adults) +
                              Number(activity.extra_pax_children) +
                              Number(activity.extra_pax_adults)
                            }}
                          </td>
                          <td>
                            {{ $localCurrency }}
                            {{ Math.ceil(findActivityTotal(activity)) }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr v-if="bookedInventory.length > 0"></tr>
                        <tr
                          v-for="(activity, index) in bookedInventory"
                          :key="'ac' + index"
                        >
                          <td>{{ activity.inventory_name }}</td>
                          <td>
                            {{
                              Number(activity.inventory_booking_children) +
                              Number(activity.inventory_booking_adults) +
                              Number(
                                activity.inventory_booking_extra_children
                              ) +
                              Number(activity.inventory_booking_extra_adults)
                            }}
                          </td>
                          <td>
                            {{ activity.inventory_booking_currency }}
                            {{
                              $roundOff(activity.inventory_booking_total_cost)
                            }}
                          </td>
                        </tr>
                        <tr></tr>

                        <tr v-if="proofOfResidency.length < 0">
                          <td>
                            <b>Proof Of residency </b>
                          </td>
                        </tr>
                        <tr v-if="proofOfResidency.length < 0">
                          <table>
                            <thead>
                              <tr>
                                <td>Residency</td>
                                <td>Point Of Proof</td>
                                <td>First Name</td>
                                <td>Last Name</td>
                                <td>Document Id</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(proof, idx) in proofOfResidency"
                                :key="'proof' + idx"
                              >
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.payment_person }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.proof_point }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.first_name }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.last_name }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.payment_person }}
                                </td>
                                <td
                                  v-if="
                                    proof.first_name != '' &&
                                    proof.last_name != '' &&
                                    proof.document_id != ''
                                  "
                                >
                                  {{ proof.document_id }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>

                        <tr>
                          <td>
                            <b>Destination : </b>
                            {{ this.gate_pass.destination_name }}
                          </td>
                        </tr>
                        <tr>
                          <td><h2>Total</h2></td>
                          <td></td>
                          <td>
                            <h2>{{ $localCurrency }} {{ totalPrice }}</h2>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <div
                        class="col-md-4 col-lg-offset-2"
                        v-if="route === 'EditBooking'"
                      >
                        <v-switch
                          v-model="gate_pass.send_mail"
                          label="Send Email to client"
                        >
                        </v-switch>
                      </div>
                      <div class="col-sm-6">
                        <v-btn
                          :depressed="true"
                          color="primary"
                          v-if="route === 'NewBooking'"
                          @click.prevent="doBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Complete Booking</v-btn
                        >
                        <v-btn
                          :depressed="true"
                          color="error"
                          v-if="route === 'EditBooking'"
                          @click.prevent="editBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Amend Booking</v-btn
                        >
                        <v-btn
                          :depressed="true"
                          color="#800080"
                          class="white--text"
                          v-if="route === 'PostponeBooking'"
                          @click.prevent="postponeBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Postpone Booking</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-snackbar
                :multi-line="true"
                :right="true"
                :vertical="true"
                :timeout="6000"
                color="error"
                v-model="snackbar"
              >
                Destination must be provided
                <v-btn flat @click="snackbar = false"> Close </v-btn>
              </v-snackbar>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
    {{ updateGateEntry }}
    {{ conservationFeesProofData }}
  </div>
</template>

<script>
import FacilityBooking from "./FacilityBooking";
import InventoryBooking from "./InventoryBooking";
import ConservationFees from "./ConservationFees";
import VehicleFees from "./VehicleFees";
import ResidencyProof from "./ResidencyProof";
export default {
  components: {
    VehicleFees,
    ConservationFees,
    InventoryBooking,
    FacilityBooking,
    "residency-proof": ResidencyProof,
  },
  name: "gate-entry-ticket",
  created() {
    this.$store.dispatch("get_all_destinations");
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_all_gates");
    this.$store.dispatch("get_all_entry_modes");
  },
  data() {
    return {
      start_date: this.$moment().format("YYYY-MM-DD"),
      backdate_today: this.$moment().subtract(7, "d").format("YYYY-MM-DD"),
      active: null,
      requiredRules: [(v) => !!v || "This field is required"],
      snackbar: false,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      route: this.$route.name,
      gate_pass: {
        checking_in: "",
        currency: this.$store.state.CurrencyStore.browser_currency,
        currency_id: this.$store.state.CurrencyStore.browser_currency_id,
        type: "FF9330A3",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        code: "",
        destination: "",
        check_in: this.$moment().format("YYYY-MM-DD"),
        check_out: this.$moment().format("YYYY-MM-DD"),
        session_id: localStorage.getItem("lkjhgfdsa"),
        promo_code: "",
        destination_name: "",
        note: "",
        send_mail: false,
        country_details: {},
        entry_mode: "",
        entry_point: "",
        mode_registration: "",
        kra_pin_number:""
        
      },
      air: false,
      road: false,
      selectAccomodation: [],
      selectedActivities: [],
    };
  },
  computed: {
    allEntryPoints: function () {
      let allEntry = this.allGates;

      let res = [];
      if (this.gate_pass.entry_mode != "") {
        for (let i = 0; i < allEntry.length; i++) {
          if (allEntry[i].entry_mode_public_id == this.gate_pass.entry_mode) {
            res.push(allEntry[i]);
          }
        }
      }

      return res;
    },
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency_id;
    },
    totalPrice: function () {
      // activity total
      var activity = 0;
      if (this.chosenInventory.length > 0) {
        for (var i = 0; i < this.chosenInventory.length; i++) {
          activity = activity + this.findActivityTotal(this.chosenInventory[i]);
        }
      }
      if (this.bookedInventory.length > 0) {
        for (var x = 0; x < this.bookedInventory.length; x++) {
          activity =
            activity + this.findOldActivityTotal(this.bookedInventory[x]);
        }
      }
      // facility total
      var facility = 0;
      var external_facility = 0;
      var old_external_facility = 0;
      if (this.chosenFacilities.length > 0) {
        for (var j = 0; j < this.chosenFacilities.length; j++) {
          facility = facility + this.facilityTotal(this.chosenFacilities[j]);
        }
      }
      if (this.bookedFacilities.length > 0) {
        for (var f = 0; f < this.bookedFacilities.length; f++) {
          facility = facility + this.oldFacilityTotal(this.bookedFacilities[f]);
        }
      }
      if (this.chosenExternalFacilities.length > 0) {
        for (var k = 0; k < this.chosenExternalFacilities.length; k++) {
          external_facility =
            external_facility +
            this.externalFacilityTotal(this.chosenExternalFacilities[k]);
        }
      }
      if (this.finExternalFacilities.length > 0) {
        for (var m = 0; m < this.finExternalFacilities.length; m++) {
          let amount = this.convert1(
            this.finExternalFacilities[m].facility_booking_currency,
            this.finExternalFacilities[m].facility_booking_total_cost
          ).amount;
          old_external_facility = old_external_facility + amount;
        }
      }

      // vehicle total
      var vehicleData = this.vehicleTotal;
      // conservation total
      var conservationData = this.conservationTotal;
      return Math.ceil(
        Number(activity) +
          Number(facility) +
          vehicleData +
          conservationData +
          Number(external_facility) +
          Number(old_external_facility)
      );
    },
    disabled_settings: function () {
      var startDate = this.$moment().format("YYYY-MM-DD");
      // var endDate = this.$store.state.BookingStore.local_booking.check_out
      // this.activity.date = this.$moment(startDate).format('YYYY, MM, DD')
      return {
        to: new Date(this.$moment(startDate).format("YYYY, MM, DD")),
        // from: new Date(this.$moment(endDate).add(1, 'd').format('YYYY, MM, DD'))
      };
    },
  },
  methods: {
    isSendEmailSelected() {
      if (this.gate_pass.send_mail === true) {
        this.gate_pass.send_mail = false;
      } else {
        this.gate_pass.send_mail = true;
      }
    },
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.gate_pass.phone = "+" + country.calling_code;
          instance.gate_pass.country_details = country;
        }
      });
    },

    nextTab() {
      this.active = Number(this.active + 1);
    },
    previousTab() {
      this.active = Number(this.active - 1);
    },
    checkDestination(publicId) {
      // Query for the Pricing Schedule
      var data = {
        check_in_date: this.gate_pass.check_in,
        check_out_date: this.gate_pass.check_out,
        destination: this.gate_pass.destination,
      };
      this.$store.dispatch("get_newly_scheduled_pricing", data);
      var instance = this;
      this.allDestinations.map((destination) => {
        if (publicId === destination.destination_public_id) {
          instance.gate_pass.destination_name = destination.destination_name;
        }
      });
    },
    editBooking: function () {
      this.$store.dispatch("loading_true");
      this.gate_pass.currency_id =
        this.$store.state.CurrencyStore.browser_currency_id;
      this.gate_pass.currency =
        this.$store.state.CurrencyStore.browser_currency_id;
      var data = {
        booking_id: this.$route.params.booking_id,
        guests: this.allConservationFees,
        facilities: this.chosenFacilities,
        external_facilities: this.chosenExternalFacilities,
        inventory: this.chosenInventory,
        vehicles: this.allVehicles,
        old_facilities: this.bookedFacilities,
        old_external_facilities: this.finExternalFacilities,
        old_inventory: this.bookedInventory,
        updated_bookings: this.bookedFacilities,
        multi: this.addedMultiArrivals,
        proof_of_residency: this.proofOfResidency,
      };

      Object.assign(data, this.gate_pass);
      
      this.$store.dispatch("update_booking", data);
    },
    postponeBooking: function () {
      this.$store.dispatch("loading_true");
      this.gate_pass.currency_id =
        this.$store.state.CurrencyStore.browser_currency_id;
      this.gate_pass.currency =
        this.$store.state.CurrencyStore.browser_currency_id;

      let postponeFac = JSON.parse(
        localStorage.getItem("postponed_facility_data")
      );
      let postExternalponeFac = JSON.parse(
        localStorage.getItem("postponed_external_facility_data")
      );

      let postponeInvent = JSON.parse(
        localStorage.getItem("postponed_inventory_data")
      );

      if (postponeFac == null) {
        postponeFac = [];
      } else {
        postponeFac = postponeFac;
      }
      if (postExternalponeFac == null) {
        postExternalponeFac = [];
      } else {
        postExternalponeFac = postExternalponeFac;
      }
      if (postponeInvent == null) {
        postponeInvent = [];
      } else {
        postponeInvent = postponeInvent;
      }

      for (var i = 0; i < this.bookedFacilities.length; i++) {
        let booked_facilities = this.bookedFacilities[i];
        booked_facilities["facility_booking_check_out_date"] = this.$moment(
          booked_facilities.facility_booking_check_out_date
        ).format("YYYY-MM-DD");
        booked_facilities["facility_booking_check_in_date"] = this.$moment(
          booked_facilities.facility_booking_check_in_date
        ).format("YYYY-MM-DD");
      }

      for (var i = 0; i < this.bookedExternalFacilities.length; i++) {
        let booked_external_facilities = this.bookedExternalFacilities[i];

        booked_external_facilities["facility_booking_check_out_date"] =
          this.$moment(
            booked_external_facilities.facility_booking_check_out_date
          ).format("YYYY-MM-DD");

        booked_external_facilities["facility_booking_check_in_date"] =
          this.$moment(
            booked_external_facilities.facility_booking_check_in_date
          ).format("YYYY-MM-DD");

        let facility_external_bookings =
          booked_external_facilities.facility_bookings;
        for (var j = 0; j < facility_external_bookings.length; j++) {
          let external_bookings = facility_external_bookings[j];
          external_bookings["facility_booking_check_out_date"] = this.$moment(
            external_bookings.facility_booking_check_out_date
          ).format("YYYY-MM-DD");

          external_bookings["facility_booking_check_in_date"] = this.$moment(
            external_bookings.facility_booking_check_in_date
          ).format("YYYY-MM-DD");
        }
      }

      for (var k = 0; k < this.bookedInventory.length; k++) {
        let booked_inventories = this.bookedInventory[k];
        booked_inventories["inventory_booking_date"] = this.$moment(
          booked_inventories.inventory_booking_date
        ).format("YYYY-MM-DD");
      }
      var data = {
        booking_id: this.$route.params.booking_id,
        guests: this.allConservationFees,
        facilities: postponeFac,
        external_facilities: postExternalponeFac,
        inventory: this.bookedInventory,
        vehicles: this.allVehicles,
        old_facilities: JSON.parse(localStorage.getItem("old_facility_data")),
        old_inventory: JSON.parse(localStorage.getItem("old_activity_data")),
        updated_facilities: this.bookedFacilities,
        updated_external_facilities: this.bookedExternalFacilities,
        multi: this.addedMultiArrivals,
      };
      Object.assign(data, this.gate_pass);
      this.$store.dispatch("postpone_booking", data);
    },
    getVehicleTotals: function () {
      var allVehicles = this.allVehicles;
      var size = allVehicles.length;
      var vehicles = 0;
      for (var i = 0; i < size; i++) {
        vehicles = Number(vehicles) + Number(allVehicles[i].vehicles);
      }
      return vehicles;
    },
    putFacilityData: function (data) {
      this.selectAccomodation = data;
    },
    putActivityData: function (data) {
      this.selectedActivities = data;
    },
    doBooking: function () {
      if (this.gate_pass.destination === "") {
        this.snackbar = true;
      } else {
        this.$store.dispatch("loading_true");
        this.gate_pass.currency_id =
          this.$store.state.CurrencyStore.browser_currency_id;
        this.gate_pass.currency =
          this.$store.state.CurrencyStore.browser_currency_id;
        var data = {
          guests: this.allConservationFees,
          facilities: this.chosenFacilities,
          external_facilities: this.chosenExternalFacilities,
          inventory: this.chosenInventory,
          vehicles: this.allVehicles,
          multi: this.addedMultiArrivals,
          proof_of_residency: this.proofOfResidency,
        };

        Object.assign(data, this.gate_pass);
        this.$store.dispatch("post_booking", data);
      }
    },
    putStartDate: function () {
      var date = this.gate_pass.check_in;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_in = date;
    },
    putEndDate: function () {
      var date = this.gate_pass.check_out;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_out = date;
    },
    currencyChange: function () {
      var data = this.currency;
      localStorage.setItem("currency", data);
      this.$store.state.CurrencyStore.browser_currency = data;
    },
    endDate(data) {
      let currentBooking = this.$store.state.BookingStore.booking;
      let instance = this;
      let bookingStartDate = currentBooking.booking_check_in_date;

      let bookingEndDate = currentBooking.booking_check_out_date;
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(bookingStartDate);
      const secondDate = new Date(bookingEndDate);
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      let postponedCheckInDate = new Date(instance.gate_pass.check_in);

      let postponedCheckOutDate = postponedCheckInDate.setDate(
        postponedCheckInDate.getDate() + diffDays
      );
      let postponedCheckOutDateFormatted = new Date(postponedCheckOutDate);
      instance.gate_pass.check_out = this.$moment(postponedCheckOutDate).format(
        "YYYY-MM-DD"
      );
    },
    findEntryPoints: function () {
      this.allEntryPoints;
    },
  },
};
</script>

<style scoped>
</style>
